module.exports = __webpack_public_path__ + "static/img/service-ISO27001.f5c13cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/service-ISO27001.png
// module id = gZoR
// module chunks = 0